import NavSearch from './NavSearch';

export { type NavSearchProps } from './NavSearch';
export default NavSearch;
